import {verifiedFetchJSON, type JSONRequestInit} from '@github-ui/verified-fetch'
import type {GraphQLResponse} from '@github-ui/item-picker-base/api/graphql'
import {buildItemPickersBulkActionsUrl} from '@github-ui/item-picker-base/api/urls'

/**
 * The types here align with the mutation made on the server defined here:
 * https://github.com/github/github/blob/master/app/controllers/ghui/item_pickers/projects_controller.rb
 * If the shape of that request or response changes, this type should be
 * updated to reflect any modified fields
 */

export type UpdateIssueProjectBulkRequest = {
  ids: string[]
  addToProjectIds?: string[]
  removeFromProjectIds?: string[]
}

type UpdateIssueProjectBulkResponseData = {
  updateIssuesBulk: {
    jobId: string
  }
}

export type UpdateIssueProjectBulkResponse = GraphQLResponse<UpdateIssueProjectBulkResponseData>

export async function apiUpdateIssueProjectBulk({
  ids,
  addToProjectIds,
  removeFromProjectIds,
}: UpdateIssueProjectBulkRequest): Promise<UpdateIssueProjectBulkResponse> {
  const requestUrl = buildItemPickersBulkActionsUrl()
  const body = {
    ids,
    addToProjectIds,
    removeFromProjectIds,
  }

  const init: JSONRequestInit = {
    method: 'POST',
    body,
  }

  const request = await verifiedFetchJSON(requestUrl, init)

  return (await request.json()) as UpdateIssueProjectBulkResponse
}
